import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-page-compositions",
  templateUrl: "./compositions.component.html",
  styleUrls: ["./compositions.component.scss"],
  standalone: false,
})
export class CompositionsPageComponent implements OnInit {
  private router = inject(Router);


  ngOnInit(): void {}

  go(interactionId: string) {
    this.router.navigate(["/interaction", interactionId, "recording"], {
      queryParamsHandling: "preserve",
    });
  }
}
